import React from 'react'
import translate from '../../../reusable/translate'
import ChevronUp from './ChevronUp'
import moment from 'moment'


const ReportingInfoContainer = ({ startingDate, endingDate, setCollapsed, operation }) => {
    return(
        <div>
            <div className="flex-row items-center space-between">
                <p className="p">
                    <em><b>
                        {translate({textKey: "sit.reporting.operationIs"})} {operation.privateOperation
                            ? `${translate({textKey: "sit.reporting.operationIsPrivate"})}`
                            : `${translate({textKey: "sit.reporting.operationIsPublic"})}`
                        }
                    </b>
                    </em>
                </p>
                <ChevronUp action={() => setCollapsed(true)} />
            </div>
        </div>
    )
}

export default ReportingInfoContainer


// WEBPACK FOOTER //
// ./src/components/profile/reports/components/ReportingInfoContainer.jsx